<template>
    <div>
        <highlightjs code="var x = 5;" />
    </div>
</template>

<script>
export default {
    props: {
        lang: {
            type: String
        }
    }
}
</script>
